import React from 'react';
import illustration from '../../../../../assets/poi-not-found.svg?reference';
import { NoResultsMessage } from '../../../shared/components';
import { withTranslate } from '../../../shared/i18n/translate';

export const PoiOverviewNoResults = withTranslate(({ t }) => (
	<NoResultsMessage
		title={t('shop_dine_no_result_header')}
		body={t('shop_dine_no_result_body')}
		imageSource={illustration}
	/>
));
